import headerBg from '@/assets/images/active/snail/doubleDan/header_bg.png';
import headerBg2 from '@/assets/images/active/travel/header/header_bg2.png';
import officeBtn from '@/assets/images/active/travel/header/btn_05.png';
import loginBtn from '@/assets/images/active/snail/doubleDan/loginBtn.png';
// import accountBtn from '@/assets/images/active/travel/header/btn_07.png';
import accountBtn from '@/assets/images/active/snail/doubleDan/switch.png';
import activeBtn from '@/assets/images/active/travel/header/btn_09.png';
import logoutBtn from '@/assets/images/active/snail/doubleDan/logoutBtn.png';

export const headerConfig = {
  not_logged_in: {
    background_image: headerBg,
    style: ''
  },
  logged_in: {
    background_image: headerBg,
    main_title_color: '#2E2E2E',
    sub_title_color: '#2E2E2E',
    tips_color: '#000',
    game_name: '最强蜗牛',
    top: 'top: 0.35rem',
    nologin_text: '点击登入，礼包将发送至游戏邮箱',
  },
  operation_btn: {
    office_website: {
      width: '',
      height: '',
      background_image: '',
      img: officeBtn,
      style: 'top: 0.35rem; display: none',
      link: 'https://sglxs.qingcitimes.com/'
    },
    login: {
      width: '',
      height: '',
      background_image: '',
      img: loginBtn,
      style: 'top: 0.25rem',
    },
    change_account: {
      width: '',
      height: '',
      background_image: '',
      img: accountBtn,
      style: 'top: 0.35rem;width: 1.8rem;height: 0.853333rem;transform: scale(0.9);'
    },
    join_active: {
      width: '',
      height: '',
      background_image: '',
      img: activeBtn,
      style: 'top: 0.35rem',
      link: 'https://qcg.ink/XrLOO4'
    },
    logout: {
      width: '',
      height: '',
      img: logoutBtn,
      style: 'top: 0.25rem',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/snail/doubleDan/headerConfig.js